// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingNextStepSummary_root__-CLKv"};